var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('span',{staticClass:"customer-brand-logo",class:[
    'customer-brand-logo--' + _vm.variant,
    'customer-brand-logo--' + _vm.context,
    'customer-brand-logo--surface-' + _vm.resolvedSurface,
  ]},[_c('img',{staticClass:"customer-brand-logo__image",attrs:{"src":_vm.source,"alt":_vm.alt},on:{"load":_vm.detectLogoContrast}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }